import Actions from "views/Actions/Actions.jsx";
import JobApplication from "views/JobApplication/JobApplication.jsx";
import Brokers from "views/Brokering/Brokers.jsx";
import Orders from "views/Brokering/Orders.jsx";
import Profile from "views/Profile/Profile.jsx";
import PendingActions from "views/Admin/PendingActions.jsx";
import Users from "views/Admin/Users.jsx";
import pagesRoutes from "./pages.jsx";

// @material-ui/icons
import DashboardIcon from "@material-ui/icons/Dashboard";
import Apps from "@material-ui/icons/Apps";
// import ContentPaste from "@material-ui/icons/ContentPaste";

import Place from "@material-ui/icons/Place";
import Timeline from "@material-ui/icons/Timeline";


export default [ 
  {
    collapse: true,
    admin: true,
    path: "/admin",
    name: "Admin",
    icon: DashboardIcon,
    views: [
      { path: "/admin/Users", name: "Users", component: Users },   
      { path: "/admin/Pending", name: "Pending Actions", component: PendingActions }     
    ]
  }, 
  { path: "/profile", name: "Profile", component: Profile },    
  { path: "/actions", name: "Actions Dashboard", component: Actions },
  
  // { path: "/dashboard/apply", name: "Job Application", component: JobApplication },
  // {
  //   collapse: true,
  //   path: "/admin",
  //   name: "Admin",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/field",
  //   name: "Field",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/communications",
  //   name: "Communications",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/volunteers",
  //   name: "Volunteers",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/political",
  //   name: "Political",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/fundraising",
  //   name: "Fundraising",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/treasurer",
  //   name: "Treasurer",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/legal",
  //   name: "Legal",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/technology",
  //   name: "Technology",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/scheduling",
  //   name: "Scheduling",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // }

];





// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx